import React from 'react';
import { navGroupsFor, activeKeyOf, SUBGROUPS } from '../navigation.js';

// The main menu (src/navigation.js), the same in the app and in the demo: the areas, each opening its entries when it
// is the current one (Operaciones with its subheadings Mi trabajo and Servicios). Configuración and the other actions
// stay at the foot, outside this list (`extra`). `onGo(page, { single })` opens a page. The server decides what each
// screen returns: this only reflects the entries this login may open.
export default function MainNav({ opts, page, onGo, ariaLabel = 'Navegación principal', className = 'sidebar-nav', extra = null }) {
  const active = activeKeyOf(page);
  const groups = navGroupsFor(opts);
  return (
    <nav className={className} aria-label={ariaLabel}>
      {groups.map(g => {
        const open = g.items.some(i => i.key === active);
        const single = g.items.length === 1;
        let lastSub = null;
        return (
          <div key={g.key} className="nav-group">
            <button type="button" className={'nav-item ' + (open ? 'active' : '')}
              aria-current={single && open ? 'page' : undefined} aria-expanded={single ? undefined : open}
              onClick={() => onGo(g.items[0].key, { single })}>
              <span>{g.label}</span>
            </button>
            {open && !single && (
              <div className="nav-sub">
                {g.items.map(item => {
                  const heading = item.sub && item.sub !== lastSub ? SUBGROUPS[item.sub] : null;
                  lastSub = item.sub || null;
                  return (
                    <React.Fragment key={item.key}>
                      {heading && <div className="nav-subheading" role="presentation">{heading}</div>}
                      <button type="button" className={'nav-item ' + (active === item.key ? 'active' : '')}
                        aria-current={active === item.key ? 'page' : undefined} onClick={() => onGo(item.key, { single: true })}>
                        {item.label}
                      </button>
                    </React.Fragment>
                  );
                })}
              </div>
            )}
          </div>
        );
      })}
      {extra}
    </nav>
  );
}
